<div class="full-page w-100 px-0 h-100">
  <div class="login-container h-100">
    <div class="login-details text-center rounded">
      <img class="logo" src="assets/images/login-registration/maintenance.png" draggable="false" />

      <div class="font-size-14">We’re currently undergoing scheduled maintenance. We should be back shortly!</div>
    </div>
  </div>
</div>
